export interface Iqrcode {
    type: QrType,
    qrText: string,
    logoSrc: string,
    qrColor: string,
    bgColor: string,
}

export enum QrType {
    URL = "url",
    TEXT = "text",
    PHONE = "phone",
    EMAIL = "email",
    LINK_TREE = "linktree",
    FORM = "form"
}
